export class DOAbnormalOperationUserBean {
  userName: string;
  operationDate: Date;

  constructor() {
    this.userName = "";
    this.operationDate = new Date();
  }
}
